import { v4 as uuidv4 } from 'uuid';
/**
 * Generates random entity identifier.
 */
export function generateEntityId() {
    return uuidv4();
}
//# sourceMappingURL=entity.js.map